import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import schoolLogo from '../school-brand.jpg';

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, phone, message })
      });
      if (response.ok) {
        setSubmitted(true);
      } else {
        alert("Failed to send message. Please try again.");
      }
    } catch (err) {
      alert("Network error.");
    }
  };

  return (
    <div
      style={{
        padding: '40px 16px',
        maxWidth: '700px',
        margin: '0 auto',
        color: '#111827',
        fontFamily: 'inherit',
        boxSizing: 'border-box',
        width: '100%',
        overflowX: 'hidden'
      }}
    >
      {/* Header with Logo Watermark */}
      <div 
        style={{ 
          textAlign: 'center', 
          marginBottom: '40px', 
          position: 'relative', 
          overflow: 'hidden', 
          padding: '20px 10px' 
        }}
      >
        {/* Subtle Watermark Logo Background */}
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '220px', height: '220px', backgroundImage: `url(${schoolLogo})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', opacity: 0.10, pointerEvents: 'none', zIndex: 0 }} />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <div
            style={{
              color: '#2563eb',
              fontSize: '0.85rem',
              fontWeight: '800',
              letterSpacing: '1px',
              marginBottom: '10px'
            }}
          >
            GET IN TOUCH
          </div>

          <h1
            style={{
              fontSize: 'clamp(2rem, 5vw, 3.2rem)',
              fontWeight: '800',
              margin: '0 0 15px',
              letterSpacing: '-1px'
            }}
          >
            Contact Support
          </h1>

          <p
            style={{
              color: '#64748b',
              fontSize: '1rem',
              lineHeight: '1.6',
              maxWidth: '550px',
              margin: '0 auto'
            }}
          >
            Have a question about managing your students, calendar, or account?
            We're here to help you get the most out of Lesson-Lane.
          </p>
        </div>
      </div>

      {submitted ? (
        <div
          style={{
            background: '#ffffff',
            padding: '50px 30px',
            borderRadius: '20px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 10px 30px rgba(15, 23, 42, 0.04)',
            textAlign: 'center'
          }}
        >
          <div
            style={{
              width: '64px',
              height: '64px',
              margin: '0 auto 20px',
              borderRadius: '50%',
              background: '#dcfce7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '28px',
              color: '#16a34a'
            }}
          >
            ✓
          </div>
          <h2 style={{ fontSize: '1.8rem', fontWeight: '800', marginBottom: '10px', color: '#111827' }}>
            Message Sent Successfully
          </h2>
          <p style={{ color: '#64748b', fontSize: '1rem', lineHeight: '1.6', marginBottom: '30px' }}>
            Thank you for reaching out. Our support team has received your message and will get back to you shortly.
          </p>
          <Link
            to="/"
            style={{
              padding: '12px 25px',
              backgroundColor: '#2563eb',
              color: '#ffffff',
              borderRadius: '10px',
              fontWeight: '700',
              textDecoration: 'none',
              display: 'inline-block'
            }}
          >
            Return to Home
          </Link>
        </div>
      ) : (
        <div
          style={{
            background: '#ffffff',
            padding: '40px',
            borderRadius: '20px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 10px 30px rgba(15, 23, 42, 0.04)',
            boxSizing: 'border-box'
          }}
        >
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
              <label style={{ fontSize: '0.75rem', color: '#334155', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '7px', display: 'block' }}>
                Your Name
              </label>
              <input
                type="text"
                placeholder="Full name"
                value={name}
                onChange={e => setName(e.target.value)}
                required
                style={{
                  padding: '13px 14px',
                  background: '#ffffff',
                  border: '1px solid #cbd5e1',
                  color: '#111827',
                  borderRadius: '10px',
                  fontSize: '15px',
                  width: '100%',
                  boxSizing: 'border-box',
                  outline: 'none'
                }}
              />
            </div>

            <div>
              <label style={{ fontSize: '0.75rem', color: '#334155', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '7px', display: 'block' }}>
                Email Address
              </label>
              <input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={{
                  padding: '13px 14px',
                  background: '#ffffff',
                  border: '1px solid #cbd5e1',
                  color: '#111827',
                  borderRadius: '10px',
                  fontSize: '15px',
                  width: '100%',
                  boxSizing: 'border-box',
                  outline: 'none'
                }}
              />
            </div>

            <div>
              <label style={{ fontSize: '0.75rem', color: '#334155', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '7px', display: 'block' }}>
                Telephone (Optional)
              </label>
              <input
                type="tel"
                placeholder="Phone number"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                style={{
                  padding: '13px 14px',
                  background: '#ffffff',
                  border: '1px solid #cbd5e1',
                  color: '#111827',
                  borderRadius: '10px',
                  fontSize: '15px',
                  width: '100%',
                  boxSizing: 'border-box',
                  outline: 'none'
                }}
              />
            </div>

            <div>
              <label style={{ fontSize: '0.75rem', color: '#334155', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '7px', display: 'block' }}>
                Message
              </label>
              <textarea
                placeholder="How can we help you?"
                rows="5"
                value={message}
                onChange={e => setMessage(e.target.value)}
                required
                style={{
                  padding: '13px 14px',
                  background: '#ffffff',
                  border: '1px solid #cbd5e1',
                  color: '#111827',
                  borderRadius: '10px',
                  fontSize: '15px',
                  width: '100%',
                  boxSizing: 'border-box',
                  outline: 'none',
                  resize: 'vertical',
                  fontFamily: 'inherit'
                }}
              />
            </div>

            <button
              type="submit"
              style={{
                padding: '14px 25px',
                backgroundColor: '#2563eb',
                color: '#ffffff',
                border: 'none',
                borderRadius: '10px',
                fontWeight: '700',
                cursor: 'pointer',
                fontSize: '15px',
                boxShadow: '0 4px 10px rgba(37, 99, 235, 0.18)',
                width: '100%',
                marginTop: '10px'
              }}
            >
              Send Message ➔
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default Contact;